<template>
  <div class="page __bc-f2">
    <!-- 页面下拉刷新 -->
    <cp-page-refresh @refresh="refresh" ref="pageRefresh">
      <!-- 公共头部组件 -->
      <common-header />
      <div class="container">
        <!-- swiper新闻 -->
        <base-swiper
          v-if="bannerList.length"
          class="video-swiper"
          :list="bannerList"
          :showBottomMask="false"
          :autoplay="autoplay"
          @handle-click-slide="handleClickSlide"
        />
        <!-- 历史上的今天 -->
        <history-today v-if="todayList.length" :list="todayList" @cb-detail="cbTodayDetail" />
        <!-- 精选事件 -->
        <wonderful-story v-if="bannerStoryList.length" @handle-click-wonderful="handleClickWonderful" :list="bannerStoryList" />
        <!-- 新闻分类tabs -->
        <common-tabs :list="typeList" :canSwipeNum="3" ref="typeTabs" @change-tab="changeTab">
          <!-- 新闻列表内容区域 -->
          <div class="news-list">
            <!-- 上滑加载组件 -->
            <cp-page-scroll
              v-show="storyList.length"
              @load="load"
              :upFinish="upFinish"
              ref="pageScroll"
            >
              <!-- 新闻列表 -->
              <news-list :list="storyList" :currentIndex="currentIndex" @cb-detail="cbNewsListDetail" />
            </cp-page-scroll>
          </div>
        </common-tabs>
      </div>
    </cp-page-refresh>
    <!-- 公共底部tabs -->
    <foot-table />
  </div>
</template>

<script>
import CommonHeader from '@/views/layout/common-header'
import FootTable from '@/views/layout/foot-table'
import BaseSwiper from '@/views/components/base-swiper'
import HistoryToday from './components/history-today'
import WonderfulStory from './components/wonderful-story'
import CommonTabs from '@/views/components/common-tabs'
import NewsList from './components/news-list'
import { story, common } from '@/agent'
import Dict from '@/core/dict'
export default {
  components: {
    'foot-table': FootTable,
    'common-header': CommonHeader,
    'base-swiper': BaseSwiper,
    'history-today': HistoryToday,
    'wonderful-story': WonderfulStory,
    'common-tabs': CommonTabs,
    'news-list': NewsList
  },
  data () {
    return {
      bannerList: [], // banner列表
      todayList: [], // 历史上今天列表
      bannerStoryList: [], // 精选事件banner列表
      storyList: [], // 分类事记列表
      params: {
        pageNum: 1,
        query: { type: 1 }
      }, // 分类事记tabs请求
      typeList: [
        { dictLabel: '历史事件' },
        { dictLabel: '人物事迹' },
        { dictLabel: '纪念日' },
      ],
      currentIndex: 0, // 当前事记分类swiper的列
      upFinish: false, // 是否已加载全部
      autoplay: true, // 轮播自动播放
    }
  },
  mounted () {
    this.$loading.show()
    this.init()
  },
  beforeRouteLeave (to, from, next) {
    // 设置滚动条位置
    const scrollTop = Math.abs(document.querySelector('.page').getBoundingClientRect().top)
    this.$util.setTabsLeaveSite(from.path, scrollTop)
    next()
  },
  methods: {
    // 初始化
    async init () {
      await this.FindBannerListByReceive()
      this.$loading.hide()
    },
    // 下拉刷新页面
    refresh () {
      this.$refs.typeTabs.handleToIndex(0) // 设置新闻分类默认选中第一个
      Object.assign(this.$data, this.$options.data()) // 重置data的数据为初始状态
      this.$refs.pageRefresh.hideFresh() // 隐藏下拉刷新
      this.init()
    },
    // 头部轮播图api
    async FindBannerListByReceive () {
      const reqData = {
        query: {
          typeId: 14 // 待完善
        },
        pageNum: 1,
        pageSize: 10,
        sorts: [{ sortPropertyName: 'orderNbr', sortType: 'DESC' }]
      }
      const result = await common.findBannerListByReceive(reqData)
      this.bannerList = [...result.data.list]
      this.bannerList = this.bannerList.map(item => {
        // 1图片，2视频
        item.bgVideo = item.categoryType == 2 ? item.src : ''
        item.imgSrc = item.categoryType == 1 ? item.src : ''
        return item
      })
      this.autoplay = this.bannerList.length > 1
      this.FindMemorabiliaListByReceive()
    },
    // 历史上的今天api
    async FindMemorabiliaListByReceive () {
      const reqData = {
        query: {
          type: 1,
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        sorts: [
          { sortPropertyName: 'year', sortType: 'ISNULL' },
          { sortPropertyName: 'year', sortType: 'ASC' },
          { sortPropertyName: 'modifyTime', sortType: 'DESC' }
        ]
      }
      const result = await story.findMemorabiliaListByReceive(reqData)
      this.todayList = [...result.data]
      this.FindBannerListByReceiveStory()
    },
    // 精选事件轮播图api
    async FindBannerListByReceiveStory () {
      const reqData = {
        query: {
          typeId: 15 // 待完善
        },
        pageNum: 1,
        pageSize: 10,
        sorts: [
          { sortPropertyName: 'orderNbr', sortType: 'ISNULL' },
          { sortPropertyName: 'orderNbr', sortType: 'ASC' }
        ]
      }
      const result = await common.findBannerListByReceive(reqData)
      this.bannerStoryList = [...result.data.list]
      this.bannerStoryList = this.bannerStoryList.map(item => {
        // 1图片，2视频
        item.bgVideo = item.categoryType == 2 ? item.src : ''
        item.imgSrc = item.categoryType == 1 ? item.src : ''
        return item
      })
      this.FindPageWithAuthority()
    },
    // 分类事记列表api，resetList重置list:[]再赋值
    async FindPageWithAuthority (resetList = false) {
      const reqData = {
        ...this.params,
        pageSize: 10,
        sorts: [
          { sortPropertyName: 'year', sortType: 'ISNULL' },
          { sortPropertyName: 'year', sortType: 'ASC' },
          { sortPropertyName: 'month', sortType: 'ISNULL' },
          { sortPropertyName: 'month', sortType: 'ASC' },
          { sortPropertyName: 'day', sortType: 'ISNULL' },
          { sortPropertyName: 'day', sortType: 'ASC' },
          { sortPropertyName: 'modifyTime', sortType: 'DESC' }
        ]
      }
      const result = await story.findPageWithAuthority(reqData)
      if (result.code === 100) {
        this.storyList = resetList
          ? result.data.list
          : [...this.storyList, ...result.data.list]
        if (this.params.pageNum >= result.data.pages) {
          this.upFinish = true
        } else {
          this.params.pageNum += 1
          this.upFinish = false
        }
        this.$refs.pageScroll.hideLoading() // 底部加载loading隐藏
      }
    },
    // 上滑加载
    load () {
      this.FindPageWithAuthority()
    },
    // 点击新闻swiper
    handleClickSlide (currentIndex) {
      const item = this.bannerList[currentIndex]
      this.formatBannerRouteTarget(item)
    },
    // 点击历史上的今天
    cbTodayDetail (item) {
      this.formatNewsRoutrTarget(item)
    },
    // 点击精选事件
    handleClickWonderful (item) {
      this.formatBannerRouteTarget(item)
    },
    // 点击分类事记列表
    cbNewsListDetail (item) {
      this.formatNewsRoutrTarget(item)
    },
    // 轮播图路由跳转处理
    formatBannerRouteTarget (item) {
      // jumpType = 1：外链；2：课程；3：详情
      if (item.jumpType === 1) {
        if (item.url) {
          this.$router.push({
            path: '/content-webview',
            query: { url: encodeURIComponent(item.url), type: Dict.linkType.iframe }
          })
        }
      } else if (item.jumpType === 2) {
        this.$router.push({
          path: '/course/detail',
          query: {
            id: item.chapterId,
            backPath: 'story',
            type: Dict.pageType.inform,
            // tabIndex: this.tabIndex
          }
        })
      } else if (item.jumpType === 3) {
        this.$router.push({
          path: '/story/detail',
          query: {
            id: item.id,
            type: Dict.pageType.advertisement // 根据类型，在详情页调不同接口
          }
        })
      }
    },
    // 大事记路由跳转
    formatNewsRoutrTarget (item) {
      this.$router.push({
        path: '/story/detail',
        query: {
          id: item.id,
          type: Dict.pageType.memory
        }
      })
    },
    // 切换事记分类
    changeTab (index) {
      this.currentIndex = index
      this.params.pageNum = 1
      // type = 1：历史事件；2: 人物事记；3: 纪念日
      this.params.query.type = index + 1
      this.FindPageWithAuthority(true)
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
}
.container {
  margin-top: 1px; // ！重要，修复第一次渲染页面tabs会吸顶bug
  padding: $header-height 0 $foot-table-height;
  // common-tabs组件背景色未吸顶灰色，吸顶白色
  /deep/.van-tabs__nav--line {
    background-color: #f2f2f2;
  }
   /deep/.van-sticky--fixed .van-tabs__nav--line {
    background-color: #fff;
  }
}
// .news-list {
//   min-height: calc(100vh - #{$header-height} - #{$foot-table-height} - 44px);
// }
</style>
